// @ts-nocheck
import React, { useRef, useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { OutputSuggest } from "../../output_suggests/OutputSuggest2";
import pullDownClassName from "../../output_suggests/PullDown.module.scss";
import axios from "axios";
import { getImageUrl } from "../../../../commons/assets_path.js";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import { RequiredText } from "../../operations/RequiredText.tsx";
import useLanguageChange from "../../../../hooks/useLanguageChange.js";

export const BrowserExtensionTriggerEasyConnectField = (props) => {
  const { t } = useLanguageChange(props.locale);

  /** @type {React.RefObject.<HTMLElement>} */
  const inputRef = useRef([]);
  const [inputDefined, setInputDefined] = useState("");
  const [inputDefinedIndex, setInputDefinedIndex] = useState("");
  const [arrayView, setArrayView] = useState([]);
  const [children, setChildren] = useState([]);
  const [childrenRef, setChildrenRef] = useState([]);
  const [idx, setIndex] = useState([]);
  const [isDestroy, setIsDestroy] = useState([]);
  const [data, setData] = useState(props.data);
  const [pulldown, setPulldown] = useState([]);
  const [initPulldown, setInitPulldown] = useState([]);
  const [isPulldownFlg, setIsPulldownFlg] = useState(false);

  const onSearch = (targetValue) => {
    const pulldownValues = [];
    initPulldown.forEach((el) =>
      el.key.toUpperCase().includes(targetValue.toUpperCase())
        ? pulldownValues.push({ key: el.key, value: el.value })
        : null,
    );
    setPulldown(pulldownValues);
  };

  const onFocus = (name) => {
    setInputDefined(name);
    setInputDefinedIndex(null);
  };

  const onFocusApiPulldown = (name, id) => {
    setInputDefined(name);
    setInputDefinedIndex(null);

    getApiPulldown(id);
  };

  const onArrayFocus = (index, listIdx, i) => {
    setInputDefinedIndex(`${listIdx}${index}`);
    setInputDefined(i);
  };

  const onArrayFocusApiPulldown = (index, listIdx, i, id) => {
    setInputDefinedIndex(`${listIdx}${index}`);
    setInputDefined(i);

    getApiPulldown(id);
  };

  const getApiPulldown = useCallback(async (id) => {
    setPulldown([]);
    setIsPulldownFlg(false);

    const formData = new FormData(document.forms[0]);
    formData.append("target_browser_extension_trigger_form_element_id", id);

    await axios
      .post(`${window.location.pathname.replace(/.*$/, "ajax_fetch_pulldown_items_from_api")}`, formData)
      .then((res) => {
        setPulldown(res.data.result);
        setInitPulldown(res.data.result);
        setIsPulldownFlg(true);
      })
      .catch(() => {
        setPulldown([]);
        setInitPulldown([]);
        setIsPulldownFlg(true);
      });
  }, []);

  const onChange = (data, index, e = null) => {
    const stash = [...data];
    stash[index].input.value = e.target.value;
    setData(stash);
  };

  const onArrayChange = (data, index, listIdx, i, e = null) => {
    const stashChildren = [...children];
    inputRef.current[i][listIdx][index].current.value = e.target.value;
    setChildren(stashChildren);
  };

  const AddForm = useCallback(
    (e, index, children) => {
      e.preventDefault();
      const stash = [...children[index]];
      const childrenStash = [...children];
      const newDataStash = JSON.parse(JSON.stringify(stash));

      newDataStash[0].forEach((data) => {
        data.input.id = "";
        data.input.childata_index = stash.length - 1;
        data.input.value = null;
      });

      stash.push(newDataStash[0]);
      inputRef.current[index][stash.length - 1] = [];
      stash[stash.length - 1].forEach((_, i) => {
        inputRef.current[index][stash.length - 1][i] = React.createRef();
      });
      childrenStash[index] = stash;
      setChildren(childrenStash);
      ArrayView();
    },
    [childrenRef, children, inputRef.current, isDestroy],
  );

  const RemoveForm = useCallback(
    (e, i, index) => {
      e.preventDefault();
      const stashDestroy = isDestroy;
      if (!stashDestroy[i]) {
        stashDestroy[i] = [];
      }
      stashDestroy[i][index] = true;
      setIsDestroy(stashDestroy);
      ArrayView();
    },
    [childrenRef, children, inputRef.current, isDestroy],
  );

  const ArrayView = useCallback(() => {
    setArrayView(
      idx.map(
        (i) =>
          children[i] &&
          children[i].map((formlist, listIdx) => (
            <div
              className={`border px-4 py-3 output-border-radius${listIdx !== 0 ? " mt-4" : ""}`}
              key={formlist.id}
              style={{
                display: `${isDestroy[i] && isDestroy[i][listIdx] ? "none" : "block"}`,
              }}
            >
              {formlist.map((form, index) => (
                <React.Fragment key={form.id}>
                  <div className="d-flex align-items-center mb-1">
                    <label>
                      {form.translate_display_name}
                      {form.required && <RequiredText />}
                    </label>
                  </div>
                  <input
                    defaultValue={form.input !== null && form.input.id !== null ? form.input.id : null}
                    name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${i}][child_inputs][][id]`}
                    type="hidden"
                    id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${i}_id`}
                  />
                  <input
                    defaultValue={form.id}
                    name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${i}][child_inputs][][browser_extension_trigger_form_element_id]`}
                    type="hidden"
                    id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${i}_browser_extension_trigger_form_element_id`}
                  />
                  <input
                    defaultValue={form.input.browser_extension_trigger_id}
                    name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${i}][child_inputs][][browser_extension_trigger_id]`}
                    type="hidden"
                    id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${i}_browser_extension_trigger_id`}
                  />
                  <input
                    defaultValue={listIdx}
                    name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${i}][child_inputs][][child_index]`}
                    type="hidden"
                    id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${i}_child_index`}
                  />
                  {form.data_type === "api_pulldown" && (
                    <div className={pullDownClassName.container}>
                      <div className={`field${index !== formlist.length - 1 ? " form-group" : ""}`}>
                        {inputDefinedIndex === `${listIdx}${index}` && (
                          <OutputSuggest
                            outputs={props.outputs}
                            target={inputRef.current[i][listIdx][index]}
                            pulldown={pulldown}
                            dataType={form.data_type}
                            onSearch={onSearch}
                            isPulldownFlg={isPulldownFlg}
                            isTrigger={true}
                          />
                        )}
                        <input
                          ref={inputRef.current[i][listIdx][index]}
                          autoComplete="off"
                          className={`form-control${
                            props.errors.length &&
                            props.errors[i] &&
                            props.errors[i][listIdx] &&
                            Object.keys(props.errors[i][listIdx][index]).length
                              ? " is-invalid"
                              : ""
                          }`}
                          type="text"
                          name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${i}][child_inputs][][value]`}
                          id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${i}_value`}
                          onFocus={() => onArrayFocusApiPulldown(index, listIdx, i, form.id)}
                          onClick={() => onArrayFocusApiPulldown(index, listIdx, i, form.id)}
                          onChange={(e) => onArrayChange(data, index, listIdx, i, e)}
                          defaultValue={form.input !== null && form.input.value ? form.input.value : ""}
                        />
                        {props.errors.length &&
                        props.errors[i] &&
                        props.errors[i][listIdx] &&
                        Object.keys(props.errors[i][listIdx][index]).length ? (
                          <div className="invalid-feedback">{props.errors[i][listIdx][index].value}</div>
                        ) : (
                          ""
                        )}
                        <small className="form-text text-muted ml-2">{form.translate_description}</small>
                      </div>
                    </div>
                  )}
                  {form.data_type === "text" && (
                    <div className={pullDownClassName.container}>
                      <div className={`field${index !== formlist.length - 1 ? " form-group" : ""}`}>
                        <input
                          ref={inputRef.current[i][listIdx][index]}
                          autoComplete="off"
                          className={`form-control${
                            props.errors.length &&
                            props.errors[i] &&
                            props.errors[i][listIdx] &&
                            Object.keys(props.errors[i][listIdx][index]).length
                              ? " is-invalid"
                              : ""
                          }`}
                          type="text"
                          name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${i}][child_inputs][][value]`}
                          id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${i}_value`}
                          onFocus={() => onArrayFocus(index, listIdx, i)}
                          onClick={() => onArrayFocus(index, listIdx, i)}
                          onChange={(e) => onArrayChange(data, index, listIdx, i, e)}
                          defaultValue={form.input !== null && form.input.value ? form.input.value : ""}
                        />
                        {props.errors.length &&
                        props.errors[i] &&
                        props.errors[i][listIdx] &&
                        Object.keys(props.errors[i][listIdx][index]).length ? (
                          <div className="invalid-feedback">{props.errors[i][listIdx][index].value}</div>
                        ) : (
                          ""
                        )}
                        <small className="form-text text-muted ml-2">{form.translate_description}</small>
                      </div>
                    </div>
                  )}
                  {form.data_type === "long_text" && (
                    <div className={pullDownClassName.container}>
                      <div className={`field${index !== formlist.length - 1 ? " form-group" : ""}`}>
                        <textarea
                          ref={inputRef.current[i][listIdx][index]}
                          autoComplete="off"
                          rows="5"
                          className={`form-control${
                            props.errors.length &&
                            props.errors[i] &&
                            props.errors[i][listIdx] &&
                            Object.keys(props.errors[i][listIdx][index]).length
                              ? " is-invalid"
                              : ""
                          }`}
                          name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${i}][child_inputs][][value]`}
                          id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${i}_value`}
                          onFocus={() => onArrayFocus(index, listIdx, i)}
                          onClick={() => onArrayFocus(index, listIdx, i)}
                          onChange={(e) => onArrayChange(data, index, listIdx, i, e)}
                          defaultValue={
                            form.input !== null && form.input.value ? form.input.value.replace(/\\n/g, "\n") : ""
                          }
                          style={{ whiteSpace: "pre-line" }}
                        />
                        {props.errors.length &&
                        props.errors[i] &&
                        props.errors[i][listIdx] &&
                        Object.keys(props.errors[i][listIdx][index]).length ? (
                          <div className="invalid-feedback">{props.errors[i][listIdx][index].value}</div>
                        ) : (
                          ""
                        )}
                        <small className="form-text text-muted ml-2">{form.translate_description}</small>
                      </div>
                    </div>
                  )}
                  {form.data_type === "pulldown" && (
                    <div className={`field${index !== formlist.length - 1 ? " form-group" : ""}`}>
                      <select
                        ref={inputRef.current[i][listIdx][index]}
                        className={`form-control${
                          props.errors.length &&
                          props.errors[i] &&
                          props.errors[i][listIdx] &&
                          Object.keys(props.errors[i][listIdx][index]).length
                            ? " is-invalid"
                            : ""
                        }`}
                        name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${i}][child_inputs][][value]`}
                        id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${i}_value`}
                        defaultValue={form.input !== null && form.input.value ? form.input.value : ""}
                        onChange={(e) => onArrayChange(data, index, listIdx, i, e)}
                      >
                        <option value="">{t("BrowserExtensionTriggerEasyConnectField.選択してください")}</option>
                        {form.browser_extension_trigger_form_element_selections.map((listData, index) => (
                          <option key={listData.id} value={listData.value}>
                            {listData.key}
                          </option>
                        ))}
                      </select>
                      {props.errors.length &&
                      props.errors[i] &&
                      props.errors[i][listIdx] &&
                      Object.keys(props.errors[i][listIdx][index]).length ? (
                        <div className="invalid-feedback">{props.errors[i][listIdx][index].value}</div>
                      ) : (
                        ""
                      )}
                      <small className="form-text text-muted ml-2">{form.translate_description}</small>
                    </div>
                  )}
                  <input
                    defaultValue={isDestroy[i] && isDestroy[i][listIdx] ? "1" : "false"}
                    type="hidden"
                    name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${i}][child_inputs][][_destroy]`}
                    id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${i}__destroy`}
                  />
                </React.Fragment>
              ))}
              {listIdx !== 0 ? (
                <div className="w-100 text-right mt-2" onClick={(e) => RemoveForm(e, i, listIdx)}>
                  <a href="#">{t("BrowserExtensionTriggerEasyConnectField.削除する")}</a>
                </div>
              ) : (
                ""
              )}
            </div>
          )),
      ),
    );
  }, [data, inputDefined, inputDefinedIndex, children, idx, childrenRef, pulldown, initPulldown]);

  useEffect(() => {
    const idx = [];
    data.forEach((form, i) => {
      if (form.data_type === "array") {
        const child = [];
        idx[i] = i;
        if (form.children_list !== null) {
          form.children_list.forEach((listdata, i) => {
            child[i] = [];
            listdata.forEach((data, idx) => {
              child[i][idx] = React.createRef();
            });
          });
        }
        setChildrenRef(children[0]);
        children[i] = form.children_list;
        inputRef.current[i] = child;
        return;
      }
      inputRef.current[i] = React.createRef();
    });
    setIndex(idx);
    ArrayView();
  }, []);

  useEffect(() => {
    ArrayView();
  }, [data, inputDefined, inputDefinedIndex, children, childrenRef, pulldown, initPulldown]);

  return (
    <>
      {data.map((form, index) => {
        return (
          <div key={index}>
            {form.data_type === "api_pulldown" && (
              <div className={pullDownClassName.container}>
                <div className="d-flex align-items-center mb-1">
                  <label>
                    {form.translate_display_name}
                    {form.required && <RequiredText />}
                  </label>
                </div>
                <input
                  type="hidden"
                  defaultValue={form.input !== null ? form.input.id : form.id}
                  name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][id]`}
                  id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_id`}
                />
                <input
                  defaultValue={form.input !== null ? form.input.browser_extension_trigger_id : ""}
                  type="hidden"
                  name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][browser_extension_trigger_id]`}
                  id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_browser_extension_trigger_id`}
                />
                <input
                  defaultValue={form.input !== null ? form.input.browser_extension_trigger_form_element_id : ""}
                  type="hidden"
                  name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][browser_extension_trigger_form_element_id]`}
                  id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_browser_extension_trigger_form_element_id`}
                />
                <div className="field form-group">
                  {inputDefined === index && (
                    <OutputSuggest
                      outputs={props.outputs}
                      target={inputRef.current[index]}
                      pulldown={pulldown}
                      dataType={form.data_type}
                      onSearch={onSearch}
                      isPulldownFlg={isPulldownFlg}
                      isTrigger={true}
                    />
                  )}
                  <input
                    ref={inputRef.current[index]}
                    autoComplete="off"
                    className={`form-control${
                      props.errors.length && props.errors[index] && Object.keys(props.errors[index]).length
                        ? " is-invalid"
                        : ""
                    }`}
                    type="text"
                    name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][value]`}
                    id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_value`}
                    defaultValue={form.input.value !== null ? form.input.value : ""}
                    onFocus={() => onFocusApiPulldown(index, form.input.browser_extension_trigger_form_element_id)}
                    onClick={() => onFocusApiPulldown(index, form.input.browser_extension_trigger_form_element_id)}
                    onChange={(e) => onChange(data, index, e)}
                  />
                  {props.errors.length && props.errors[index] && Object.keys(props.errors[index]).length ? (
                    <div className="invalid-feedback">{props.errors[index].value}</div>
                  ) : (
                    ""
                  )}
                  <small className="form-text text-muted ml-2">{form.translate_description}</small>
                </div>
              </div>
            )}
            {form.data_type === "text" && (
              <div className={pullDownClassName.container}>
                <div className="d-flex align-items-center mb-1">
                  <label>
                    {form.translate_display_name}
                    {form.required && <RequiredText />}
                  </label>
                </div>
                <input
                  type="hidden"
                  defaultValue={form.input !== null ? form.input.id : form.id}
                  name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][id]`}
                  id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_id`}
                />
                <input
                  defaultValue={form.input !== null ? form.input.browser_extension_trigger_id : ""}
                  type="hidden"
                  name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][browser_extension_trigger_id]`}
                  id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_browser_extension_trigger_id`}
                />
                <input
                  defaultValue={form.input !== null ? form.input.browser_extension_trigger_form_element_id : ""}
                  type="hidden"
                  name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][browser_extension_trigger_form_element_id]`}
                  id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_browser_extension_trigger_form_element_id`}
                />
                <div className="field form-group">
                  <input
                    ref={inputRef.current[index]}
                    autoComplete="off"
                    className={`form-control${
                      props.errors.length && props.errors[index] && Object.keys(props.errors[index]).length
                        ? " is-invalid"
                        : ""
                    }`}
                    type="text"
                    name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][value]`}
                    id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_value`}
                    defaultValue={form.input.value !== null ? form.input.value : ""}
                    onFocus={() => onFocus(index, form.input.browser_extension_trigger_form_element_id)}
                    onClick={() => onFocus(index)}
                    onChange={(e) => onChange(data, index, e)}
                  />
                  {props.errors.length && props.errors[index] && Object.keys(props.errors[index]).length ? (
                    <div className="invalid-feedback">{props.errors[index].value}</div>
                  ) : (
                    ""
                  )}
                  <small className="form-text text-muted ml-2">{form.translate_description}</small>
                </div>
              </div>
            )}
            {form.data_type === "long_text" && (
              <div className={pullDownClassName.container}>
                <div className="d-flex align-items-center mb-1">
                  <label>
                    {form.translate_display_name}
                    {form.required && <RequiredText />}
                  </label>
                </div>
                <input
                  type="hidden"
                  defaultValue={form.input !== null ? form.input.id : form.id}
                  name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][id]`}
                  id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_id`}
                />
                <input
                  defaultValue={form.input !== null ? form.input.browser_extension_trigger_id : ""}
                  type="hidden"
                  name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][browser_extension_trigger_id]`}
                  id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_browser_extension_trigger_id`}
                />
                <input
                  defaultValue={form.input !== null ? form.input.browser_extension_trigger_form_element_id : ""}
                  type="hidden"
                  name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][browser_extension_trigger_form_element_id]`}
                  id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_browser_extension_trigger_form_element_id`}
                />
                <div className="field form-group">
                  <textarea
                    ref={inputRef.current[index]}
                    autoComplete="off"
                    rows="5"
                    className={`form-control resize-none${
                      props.errors.length && props.errors[index] && Object.keys(props.errors[index]).length
                        ? " is-invalid"
                        : ""
                    }`}
                    name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][value]`}
                    id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_value`}
                    defaultValue={form.input.value !== null ? form.input.value.replace(/\\n/g, "\n") : ""}
                    onFocus={() => onFocus(index)}
                    onClick={() => onFocus(index)}
                    onChange={(e) => onChange(data, index, e)}
                    style={{ whiteSpace: "pre-wrap" }}
                  />
                  {props.errors.length && props.errors[index] && Object.keys(props.errors[index]).length ? (
                    <div className="invalid-feedback">{props.errors[index].value}</div>
                  ) : (
                    ""
                  )}
                  <small className="form-text text-muted ml-2">{form.translate_description}</small>
                </div>
              </div>
            )}
            {form.data_type === "pulldown" && (
              <div className="field form-group">
                <div className="d-flex align-items-center mb-1">
                  <label>
                    {form.translate_display_name}
                    {form.required && <RequiredText />}
                  </label>
                </div>
                <input
                  type="hidden"
                  defaultValue={form.input !== null ? form.input.id : form.id}
                  name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][id]`}
                  id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_id`}
                />
                <input
                  defaultValue={form.input !== null ? form.input.browser_extension_trigger_id : ""}
                  type="hidden"
                  name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][browser_extension_trigger_id]`}
                  id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_browser_extension_trigger_id`}
                />
                <input
                  defaultValue={form.input !== null ? form.input.browser_extension_trigger_form_element_id : ""}
                  type="hidden"
                  name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][browser_extension_trigger_form_element_id]`}
                  id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_browser_extension_trigger_form_element_id`}
                />
                <select
                  ref={inputRef.current[index]}
                  className={`form-control${
                    props.errors.length && props.errors[index] && Object.keys(props.errors[index]).length
                      ? " is-invalid"
                      : ""
                  }`}
                  name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][value]`}
                  id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_value`}
                  defaultValue={form.input.value !== null ? form.input.value : ""}
                  onChange={(e) => onChange(data, index, e)}
                >
                  <option value="">{t("BrowserExtensionTriggerEasyConnectField.選択してください")}</option>
                  {form.browser_extension_trigger_form_element_selections.map((listData, index) => (
                    <option key={listData.id} value={listData.value}>
                      {listData.translate_key}
                    </option>
                  ))}
                </select>
                {props.errors.length && props.errors[index] && Object.keys(props.errors[index]).length ? (
                  <div className="invalid-feedback">{props.errors[index].value}</div>
                ) : (
                  ""
                )}
                <small className="form-text text-muted ml-2">{form.translate_description}</small>
              </div>
            )}
            {form.data_type === "array" && children[index] && (
              <>
                <div className="field form-group">
                  <div className="d-flex align-items-center mb-1">
                    <label>
                      {form.translate_display_name}
                      {form.required && <RequiredText />}
                    </label>
                  </div>
                  <input
                    type="hidden"
                    defaultValue={form.input !== null ? form.input.id : form.id}
                    name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][id]`}
                    id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_id`}
                  />
                  <input
                    defaultValue={form.input.browser_extension_trigger_id}
                    type="hidden"
                    name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][browser_extension_trigger_id]`}
                    id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_browser_extension_trigger_id`}
                  />
                  <input
                    defaultValue={form.id}
                    type="hidden"
                    name={`browser_extension_trigger[browser_extension_trigger_form_element_inputs_attributes][${index}][browser_extension_trigger_form_element_id]`}
                    id={`browser_extension_trigger_browser_extension_trigger_form_element_inputs_attributes_${index}_browser_extension_trigger_form_element_id`}
                  />
                  {arrayView[index]}
                  <button className="btn btn-secondary my-3" onClick={(e) => AddForm(e, index, children)}>
                    {t("BrowserExtensionTriggerEasyConnectField.データを追加する")}
                  </button>
                </div>
              </>
            )}
          </div>
        );
      })}
    </>
  );
};

BrowserExtensionTriggerEasyConnectField.propTypes = {
  locale: PropTypes.string,
  errors: PropTypes.array,
  data: PropTypes.array,
  outputs: PropTypes.arrayOf(PropTypes.object),
};
